import {
  ApolloClient,
  ApolloLink,
  ApolloProvider,
  from,
  HttpLink,
  InMemoryCache,
  split,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { GraphQLWsLink } from '@apollo/client/link/subscriptions'
import { getMainDefinition } from "@apollo/client/utilities";
import { createClient } from 'graphql-ws'

import { dev_environment } from "../app/constants/constants";
import ENV from '../app/constants/env'
import { store } from "../app/store/store";
import { generateRefreshToken } from "../components/authentication/auth.thunk";
import { fetchNewAccessToken, getFbUser, isJwtExpired } from "../utils/apolloUtils/auth.utils";

const authMiddleware = new ApolloLink(async (operation, forward) => {
  const state = store.getState();
  const { userAccessToken } = state.main;

  const isTokenExpired = isJwtExpired(userAccessToken);
  const userId = state.main.user?.id;
  const oldJwt = window.localStorage.getItem("userMobToken");

  if (isTokenExpired || oldJwt) {
    if(oldJwt) {
      const fetchRefreshToken = await generateRefreshToken({ userHID: userId });
      const mobileRefreshToken = fetchRefreshToken.data?.mobileRefreshToken;
      window.localStorage.setItem("mobRefreshToken", mobileRefreshToken);
      window.localStorage.removeItem("userMobToken");
    }

    if(isTokenExpired) {
      const res: any = await getFbUser();
      const fbUid = res?.uid;

      const refreshToken = window.localStorage.getItem("mobRefreshToken");
      await fetchNewAccessToken(userId, refreshToken, fbUid);
    }
  }

  return forward(operation);
})

const wsLink = new GraphQLWsLink(createClient({
  url: ENV.DB_URL_SUBSCRIPTION ?? " ",
  connectionParams: () => {
    const state = store.getState();
    const token = state.main.userAccessToken;
    return {
      headers: {
        "content-type": "application/json",
        "authorization": token ? `Bearer ${token}` : `Bearer ${ENV.ANONYMOUS_API_KEY}`,
      },
    }
  },
  reconnect: true,
}));

const authLink = setContext((_, { headers }) => {
  const state = store.getState();
  const token = state.main.userAccessToken;
  return {
    headers: {
      ...headers,
      "authorization": token ? `Bearer ${token}` : `Bearer ${ENV.ANONYMOUS_API_KEY}`,
    }
  }
})

const httpLink = new HttpLink({
  uri: process.env.REACT_APP_DB_URL ?? "",
  headers: {
    "content-type": "application/json",
  },
});

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  wsLink,
  from([
    authMiddleware, 
    authLink,       
    httpLink,
  ]),
);

const client = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "network-only", // Used for first execution
      nextFetchPolicy: "cache-first",
    },
  },
  connectToDevTools: ENV.REACT_APP_ENVIORNMENT === dev_environment,
});

const ApolloProviderWrapper = ({ children }) => <ApolloProvider client={client}>{children}</ApolloProvider>;

export default ApolloProviderWrapper;